module.exports = __webpack_public_path__ + "img/52.fe875dda.jpg";